import axios from 'axios';

const CRSF_TOKEN_HEADER_NAME = 'X-CSRF-TOKEN';
const REQUIRED_CRSF_TOKEN_METHODS = ['POST', 'PUT'];

const fetchClient = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_MANHEIM_SUPPORT_API_URL,
    headers: {
      'Content-Type': 'application/json',
      'Accept': '*/*'
    },
    timeout: 30 * 1000 // Match Lambda timeout for cold starts
  };

  const axiosInstance = axios.create(defaultOptions);

  axiosInstance.interceptors.request.use(async (request) => {
    try {
      // Use ID token for authentication (audience = our Client ID)
      // access_token has Microsoft Graph audience, not suitable for our API
      const idToken = sessionStorage.getItem('id_token');
      if (idToken) {
        request.headers = request.headers || {};
        request.headers.Authorization = `Bearer ${idToken}`;
      }

      const { method } = request;
      if (REQUIRED_CRSF_TOKEN_METHODS.includes(method.toUpperCase())) {
        const { csrfInfo } = global.window;
        if (csrfInfo) {
          const { token } = csrfInfo;
          if (token) {
            request.withCredentials = true;
            request.headers = request.headers || {};
            if (token) {
              request.headers[CRSF_TOKEN_HEADER_NAME] = token;
            }
          }
        }
      }
      return request;
    } catch (err) {
      throw new Error(`Problem with request during pre-flight phase: ${err}`);
    }
  });

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (err) => {
      if (err.response && err.response.status === 401) {
        // Avoid redirect loop - don't redirect if already on login/callback page
        const currentPath = window.location.pathname;
        if (!currentPath.includes('/login') && !currentPath.includes('/callback')) {
          // Clear token and redirect to login
          sessionStorage.removeItem('id_token');
          window.location.href = `${window.location.protocol}//${window.location.host}/manheimsupport/login`;
        }
      }
      throw err;
    }
  );
  return axiosInstance;
};

export default fetchClient();
